import axios from 'axios';

import { toastr } from 'react-redux-toastr';
import { getToken } from '../oidc/AuthService';
// import fileSaver from 'file-saver';

export function downloadCreateActivityTemplate(downloadDto) {


    return function (dispatch) {
      //   dispatch(setBlockingState(true));
      axios
        .post("/bulkActivities/download" , downloadDto, {
          headers:
          {
            "Authorization": `Bearer ` + getToken(),
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'Pragma': 'no-cache',
            'X-Frame-Options':'DENY'
          }
        })
        .then(function (response) {
          // toastr.success(I18n.t('toastr.uploadSuccess'));
          // toastr.success("Success", response.data);
          toastr.success(response.data);
  
          dispatch({
            type: "BULK_DOWNLOAD_ACTIVITY_DATA",
            payload: {isUploaded:true}
          })
  
           //dispatch(getBulkDownloadList(downloadDto));
  
        })
        .catch(function (err) {
          if (err && err.status && (err.status === 429)) {
          } else {
            console.log(err);
          }
        });
    };
  }
// 

